import { useState, useContext, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import ApiContext from 'src/provider/API/call-service';
import AppInfoContext from 'src/provider/state-manager/appInfoProvider';
import utility from 'src/utils/utility'
import { AppText, Button, CustomContainer, FlexRow, ScreenContainer } from 'src/style';
import { ReportFilter, ServerSideTable } from 'src/component';
import helpers from 'src/utils/helpers';
import { institutionsData, institutionsColumn } from 'src/utils/tableLayout';
import { CreateInstitution } from 'src/popup';
import { QoreStaffTypes } from 'src/model';
import { useTranslation } from 'react-i18next';

const Institutions = () => {
    const navigate = useNavigate()
    const {API, downloadReport} = useContext(ApiContext)
    const {info: {qoreStaffType}, setInfoProperty} = useContext(AppInfoContext)
    const [reportData, setReportData] = useState<any>(null)
    const [report, setReport] = useState<any>(null)
    const [view, setView] = useState<string>('')
    const [resetPagination, setResetPagination] = useState<boolean>(false)
    const [userType, setUserType] = useState('')
    const {t} = useTranslation()

    const filterDataRef = useRef({})
    
    useEffect(() => {
        filterDataRef.current = {}
        handleFetchReport()
    }, [])

    useEffect(() => {
        if (qoreStaffType) setUserType(qoreStaffType)
    }, [qoreStaffType])

    async function handleFetchReport (pageNumber = 1, pageSize = 10, isDownload = false) {
        const response = await API.getInstitutionsReport(pageNumber, pageSize, {...filterDataRef.current, returnMax: isDownload})
        if (response) {
            if (isDownload) {
                return downloadReport(response, t('report.institutions.downloadFilename'))
            }
            setReportData(response)
            setReport(helpers.addSerialNumberToItems(response.data, {pageNumber, pageSize}))
        }
    }

    async function handleSelectedInstitution (data: any) {
        await setInfoProperty('selectedInstitution', data)
        navigate('/dashboard/institution-details')
    }

    function handleClear () {
        filterDataRef.current = {}
        handleFetchReport()
        setResetPagination(!resetPagination)
    }

    return (
        <>
            <ScreenContainer>
                <CustomContainer topMargin='3' className='no-submenu-container'>
                    <FlexRow 
                        justifyContent='space-between' alignItems='flex-start' 
                        bottomMargin='1' gap='1.5' wrap='wrap'
                    >
                        <AppText textSize='3' color='#101828' fontWeight="600">
                            {t('report.institutions.tableTitle')}
                        </AppText>
                        { userType === QoreStaffTypes.ADMIN &&
                            <Button
                                width='15.2'
                                titleSize='1.4' fontWeight='600'
                                height='4' radius='0.8' hoverColor='#0D968F'
                                hoverBgColor='#fff' borderColor='#0D968F'
                                onClick={() => setView('create-institution')}
                            >
                                {t('report.institutions.button.create')}
                            </Button>
                        }
                    </FlexRow>
                    <ServerSideTable
                        tableData={report}
                        tableColumns={institutionsColumn(handleSelectedInstitution, t)} 
                        dataFetchMethod={handleFetchReport}
                        totalRows={reportData?.total}
                        customStyle
                        shouldResetPagination={resetPagination}
                        //canSearch
                        canFilter={() => setView('report')}
                        canClear={handleClear}
                        downloadAction={() => handleFetchReport(1, 10, true)}
                    />
                </CustomContainer>
            </ScreenContainer>
            { view === 'report' &&
                <ReportFilter
                    type='institutions'
                    top={26}
                    onApplyFilter={handleFetchReport}
                    setFilterData={(data: any) => {filterDataRef.current = data}}
                    close={() => setView('')} 
                />
            }
            { view === 'create-institution' &&
                <CreateInstitution
                    getInstitutions={handleFetchReport}
                    close={() => setView('')}
                />
            }
        </>
    )
}

export default utility.routeData('institutions', 'Institutions', <Institutions/>)